import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Testimonials.css';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Testimonials = () => {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    axios.get(`${API}/feedback/approved`)
      .then((r) => setItems(Array.isArray(r.data) ? r.data : []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (items.length <= 1) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % items.length), 6000);
    return () => clearInterval(t);
  }, [items]);

  if (!items.length) return null;
  const safeIdx = idx % items.length;
  const t = items[safeIdx];

  return (
    <div className="mb-32" data-testid="testimonials-section">
      <h2 className="text-[32px] md:text-[48px] font-semibold leading-[1.1] text-gray-900 mb-4">
        What Clients Say
      </h2>
      <p className="text-[18px] text-gray-600 mb-12">
        Real feedback from the people I've partnered with
      </p>
      <div className="bg-gray-50 p-6 sm:p-12 border border-gray-200 shadow-md text-center min-h-[280px] flex flex-col items-center justify-center">
        <div key={safeIdx} className="cx-testimonial-fade max-w-3xl">
          <p className="text-[20px] md:text-[24px] text-gray-900/90 leading-[1.6] mb-8">
            &ldquo;{t.feedback}&rdquo;
          </p>
          <div className="text-[18px] font-semibold text-[#085041]" data-testid="testimonial-name">{t.name}</div>
          <div className="text-[16px] text-gray-500">
            {[t.company, t.industry].filter(Boolean).join(' · ')}
          </div>
        </div>
        {items.length > 1 && (
          <div className="flex gap-2 mt-8" data-testid="testimonial-dots">
            {items.map((_, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                aria-label={`Show testimonial ${i + 1}`}
                data-testid={`testimonial-dot-${i}`}
                className={`w-2.5 h-2.5 rounded-full transition-colors ${i === safeIdx ? 'bg-[#00D4B4]' : 'bg-gray-300 hover:bg-gray-400'}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Testimonials;
